import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

const FieldText = ({ control, name, disabled, label, rules, type = 'text' }) => {
  return (
    <Controller
      name={name}
      // defaultValue=""
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          fullWidth
          variant="filled"
          type={type}
          disabled={disabled}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      )}
    />
  );
};

export default FieldText;
